import { useQuery } from '@apollo/client';
import { graphql } from '~/apollo/generated/v4';
import { NotFound } from '~/components/common/NotFound';
import { SpinnerPlaceholder } from '~/components/common/SpinnerPlaceholder';
import { useBreadcrumb } from '~/components/layout/Breadcrumb';
import { VomDetailPage } from '~/components/vom/VomDetailPage';
import { useRouteParam } from '~/hooks/routing';

export const VIRTUAL_OUTCROP_DETAIL_TAB = graphql(`
  query VirtualOutcropDetailTab($id: ID!) {
    virtualOutcropModelGet(id: $id) {
      ...vomParts
      pictures {
        ...pictureParts
        file {
          ...fileParts
        }
      }
      georeferences {
        ...georeferenceParts
      }
      interpreted
      cesiumAsset {
        id
        approved
        state
      }
    }
  }
`);

export default function VomDetailRoute() {
  const vomId = useRouteParam('vomId', parseInt);

  const { data, loading } = useQuery(VIRTUAL_OUTCROP_DETAIL_TAB, {
    variables: { id: vomId },
  });

  const vom = data?.virtualOutcropModelGet;

  useBreadcrumb(
    'routes/outcrop/$outcropId/virtual-outcrops/$vomId',
    vom?.name ?? 'Virtual Outcrop',
  );

  if (loading) return <SpinnerPlaceholder />;
  if (!vom) return <NotFound />;

  return <VomDetailPage vom={vom} />;
}
